import React, { useState, useEffect, useRef, useId } from 'react';
import './Modal.css';

// window.bootstrap = require('https://cdn.jsdelivr.net/npm/bootstrap@5.2.2/dist/js/bootstrap.bundle.min.js');

const Modal = ({ children, title, id, show, onClose }) => {

    const [message, setMessage] = useState('');
    const closeModalBtn = useRef();
    const modalObjRef = useRef(null);

    //console.log(children);
    // Setup event listener for modal close
    useEffect(() => {
        if (!onClose || !id) return;
        
        let modalElement = document.getElementById(id);
        if (!modalElement) return;

        const handleHidden = () => {
            onClose();
        };

        modalElement.addEventListener('hidden.bs.modal', handleHidden);

        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hidden.bs.modal', handleHidden);
            }
        };
    }, [id, onClose]);

    // Handle show/hide modal
    useEffect(() => {
        if (!id) return;

        let modalElement = document.getElementById(id);
        if (!modalElement) return;

        if (show) {
            let myModal = new window.bootstrap.Modal(modalElement);
            myModal.show();
            modalObjRef.current = myModal;
        } else if (modalObjRef.current) {
            modalObjRef.current.hide();
        }

        return () => {
            // Cleanup if needed
        };
    }, [show, id]);

    return (<div className={"modal fade right come-from-modal"} id={id} tabIndex="-1" aria-labelledby="newUserModalLabel" aria-hidden="true">
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                    <p className="modal-title fs-5 h3">{title}</p>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeModalBtn}></button>
                </div>
                <div className="modal-body">
                    {children}
                </div>
            </div>
        </div>
    </div>)
}

export default Modal